module.exports = __webpack_public_path__ + "static/emerald-orb-2d6f65356a3d47f35bef1b4627cd166d.png";